// ... existing action types ...

// Inventory Selection Types
export const SET_SELECTED_INVENTORY_ITEMS = 'SET_SELECTED_INVENTORY_ITEMS';
export const CLEAR_SELECTED_INVENTORY_ITEMS = 'CLEAR_SELECTED_INVENTORY_ITEMS';
export const TOGGLE_INVENTORY_ITEM = 'TOGGLE_INVENTORY_ITEM';
